/*
 * Amplify legacy UI (Shadow DOM) 向け: Android 手入力で内部 state と DOM が
 * ずれる問題を避けるため、submit 前に input 実値を state へ同期する。
 */

function collectShadowInputs(node) {
	if (!node) return [];
	const found = [...node.querySelectorAll('input')];
	node.querySelectorAll('*').forEach((el) => {
		if (el.shadowRoot) {
			found.push(...collectShadowInputs(el.shadowRoot));
		}
	});
	return found;
}

/**
 * host の shadow DOM 内 input に blur → input/change を発火し Amplify state を同期する。
 * @param {Element|null|undefined} hostEl amplify-sign-in / amplify-sign-up 等
 */
export function syncAmplifyFormInputs(hostEl) {
	const root = hostEl?.shadowRoot;
	collectShadowInputs(root).forEach((input) => {
		input.blur();
		input.dispatchEvent(new Event('input', { bubbles: true }));
		input.dispatchEvent(new Event('change', { bubbles: true }));
	});
}

/**
 * 同期後に shadow DOM 内 form を submit する（slotted カスタムボタン用）。
 * @param {Element|null|undefined} hostEl
 */
export function submitAmplifyForm(hostEl) {
	syncAmplifyFormInputs(hostEl);
	const form = hostEl?.shadowRoot?.querySelector('form');
	if (form?.requestSubmit) {
		form.requestSubmit();
	} else {
		form?.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
	}
}

/**
 * Amplify デフォルト送信ボタン向け: form submit の capture で同期する。
 * host が後からマウントされる場合に備え短時間リトライする。
 * @param {string} hostSelector 例: 'amplify-sign-up'
 * @returns {() => void} cleanup
 */
export function attachAmplifySubmitSync(hostSelector) {
	let cleaned = false;
	let detach = () => {};

	const tryAttach = () => {
		if (cleaned) return true;
		const hostEl = document.querySelector(hostSelector);
		const form = hostEl?.shadowRoot?.querySelector('form');
		if (!form) return false;

		const onSubmitCapture = () => {
			syncAmplifyFormInputs(hostEl);
		};
		form.addEventListener('submit', onSubmitCapture, true);
		detach = () => form.removeEventListener('submit', onSubmitCapture, true);
		return true;
	};

	if (tryAttach()) {
		return () => {
			cleaned = true;
			detach();
		};
	}

	const timer = setInterval(() => {
		if (tryAttach()) {
			clearInterval(timer);
		}
	}, 100);
	const timeout = setTimeout(() => clearInterval(timer), 5000);

	return () => {
		cleaned = true;
		clearInterval(timer);
		clearTimeout(timeout);
		detach();
	};
}
